import { create } from "zustand";
import { combine } from "zustand/middleware";
import React from "react";

const modalStore = create(
  combine(
    {
      list: [],
    },
    (set, get) => ({
      openModal: ({ modal, props, key }) => {
        const newKey = key || Math.random().toString(36).substring(2, 9);
        set({
          list: [
            ...get().list,
            { key: newKey, component: modal, props: { ...props, show: true } },
          ],
        });
        return newKey;
      },
      closeModal: (key) => {
        set({
          list: get().list.map((item) =>
            item.key === key
              ? { ...item, props: { ...item.props, show: false } }
              : item
          ),
        });
        setTimeout(() => {
          set({
            list: get().list.filter((item) => item.key !== key),
          });
        }, 300); // Allow animation time for Ant Design modal exit
      },
      closeAllModals: () => set({ list: [] }),
    })
  )
);

export const ModalService = {
  open: ({ modal, props, key }) => {
    const generatedKey = modalStore.getState().openModal({ modal, props, key });
    return {
      key: generatedKey,
      close: () => ModalService.close(generatedKey),
    };
  },
  close: (key) => {
    modalStore.getState().closeModal(key);
  },
  closeAll: () => {
    modalStore.getState().closeAllModals();
  },
};

export const ModalProvider = () => {
  const modals = modalStore((state) => state.list);

  return (
    <>
      {modals.map(({ key, component: Component, props }) => (
        <Component
          key={key}
          {...props}
          onClose={() => ModalService.close(key)} // Ensure the modal closes when `onClose` is triggered
        />
      ))}
    </>
  );
};
